export default function (value) {
    return ('0' + value).slice(-2);
};


// WEBPACK FOOTER //
// ./assets/js/filters/formatedDay.js